import { UnknownAction } from "../../shared/schema/AgentActionSchemas";
import { AgentActionUtil, registerActionUtil } from "./AgentActionUtil";

/** Fallback for an action type this client has no util for; does nothing. */
export const UnknownActionUtil = registerActionUtil(
  class UnknownActionUtil extends AgentActionUtil<UnknownAction> {
    static override type = "unknown" as const;

    override getInfo() {
      // Don't show anything in the UI for unknown actions
      return null;
    }
  },
);
